import { render, staticRenderFns } from "./modal-archive-proof.vue?vue&type=template&id=44ecdc9a&scoped=true&"
import script from "./modal-archive-proof.vue?vue&type=script&lang=js&"
export * from "./modal-archive-proof.vue?vue&type=script&lang=js&"
import style0 from "./modal-archive-proof.vue?vue&type=style&index=0&id=44ecdc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ecdc9a",
  null
  
)

export default component.exports